import React, { ReactNode } from 'react';

import { Header, IHeaderProps } from '../Header';

import styles from './Page.module.scss';

export interface IPageProps {
    headerProps: IHeaderProps;
    children?: ReactNode;
}

export const Page = ({ headerProps, children }: IPageProps) => {
    return (
        <div className={styles.page}>
            <Header {...headerProps} />
            <div className={styles.headerGap} />
            <div className={styles.pageContent}>{children}</div>
        </div>
    );
};
